import { useState } from 'react';
import { useWebPushRegistration } from '@/hooks/useWebPush';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Bell, X } from 'lucide-react';

export function PushNotificationsBootstrap() {
  const { user } = useAuth();
  const {
    ready,
    loading,
    supported,
    configured,
    permission,
    subscribed,
    requestBrowserNotifications,
  } = useWebPushRegistration();
  const [dismissed, setDismissed] = useState(false);

  if (
    !user
    || dismissed
    || !ready
    || !supported
    || !configured
    || subscribed
    || permission !== 'default'
  ) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[80] w-[min(92vw,360px)] rounded-2xl border bg-card p-4 shadow-xl">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-primary/10 p-2 text-primary">
          <Bell className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="font-medium">Enable browser notifications</p>
              <p className="mt-1 text-sm text-muted-foreground">
                Get dispatches, status changes, and case messages even when this tab is not active.
              </p>
            </div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-7 w-7 shrink-0"
              onClick={() => setDismissed(true)}
              aria-label="Dismiss notification prompt"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <div className="mt-3 flex gap-2">
            <Button
              type="button"
              size="sm"
              onClick={() => requestBrowserNotifications()}
              disabled={loading}
            >
              {loading ? 'Enabling...' : 'Enable'}
            </Button>
            <Button type="button" size="sm" variant="outline" onClick={() => setDismissed(true)}>
              Later
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PushNotificationsBootstrap;
